import { useEffect, useState } from "react"
import { useRecoilState } from "recoil"

import {
  filtersValuesState,
  recordCountValuesState,
  recordCountNumber,
  FinalWhereClsAM,
  Spiner,
} from "../../atoms/audienceCatBuilderAtom"
import { dealerInfo } from "../../atoms/DealerAtom"
import arrowup from "../../assets/images/arrowup.png"
import { createSQLYesSentence } from "./utils"
import { postApiHelper } from "../../util/apiHelpers"

const IntHuntingShooting = ({ setInt }) => {
  const [huntingShooting, setHuntingShooting] = useState([
    { name: "Yes", id: "0", selected: false },
  ])
  const [filtersValues, setFiltersValues] = useRecoilState(filtersValuesState)
  const [recordRequest, setRecordRequest] = useRecoilState(
    recordCountValuesState
  )
  const setSpiner = useRecoilState(Spiner)[1]
  const [AdWhereClsAM, setAdWhereClsAM] = useRecoilState(FinalWhereClsAM)
  const setRecordCount = useRecoilState(recordCountNumber)[1]
  const dealerInfoValue = useRecoilState(dealerInfo)[0]

  const huntingShootingPersistency = () => {
    const huntingShootingList = [{ name: "Yes", id: "0", selected: false }]
    for (let i = 0; i < huntingShootingList.length; i++) {
      if (filtersValues.huntingShooting) {
        filtersValues.huntingShooting &&
          (huntingShootingList[i] = {
            ...huntingShootingList[i],
            selected: true,
          })
      }
    }
  }

  useEffect(() => {
    huntingShootingPersistency()
  }, [])

  const changeInput = (event) => {
    const huntingShootingAux = [...huntingShooting]
    huntingShootingAux[
      event.target.id.substring(0, event.target.id.length - 15)
    ].selected = event.target.checked
    setHuntingShooting(huntingShootingAux)
  }

  const handleHuntingShootingChange = () => {
    if (huntingShooting[0].selected) {
      sendRequestCount(`'Y'`)
      setFiltersValues({ ...filtersValues, huntingShooting: true })
      setRecordRequest({ ...recordRequest, huntingShooting: true })
    } else {
      sendRequestCount("")
      setFiltersValues({ ...filtersValues, huntingShooting: false })
    }
    setInt({
      outdoorsmen: false,
      hunting: false,
      fishing: false,
      campingHiking: false,
      huntingShooting: true,
      motorcycling: false,
    })
  }

  const sendRequestCount = (recordRequestBody) => {
    setSpiner(true)
    const WhereClsAM = createSQLYesSentence(
      recordRequestBody,
      "C.Hunting_Shooting",
      AdWhereClsAM
    )
    setAdWhereClsAM({ sql: WhereClsAM })
    postApiHelper(`BigQuery/getConsumersCountFromBigQuery`, {
      sql: WhereClsAM,
      roofTopID: dealerInfoValue.rooftopID,
      sqlService: filtersValues.excludeService
        ? `${filtersValues.excludeService}`
        : "",
      sqlSales: filtersValues.excludeSales
        ? `${filtersValues.excludeSales}`
        : "",
    }).then((res) => {
      const resBigQuery = res.data[0]
      const resBigQueryExclude = res.data[1]?.numpid
      if (filtersValues.excludeSales && filtersValues.excludeService) {
        setRecordCount({
          value: resBigQuery.numpid,
          amountExcludeService: resBigQueryExclude,
          amountExcludeSales: res.data[2]?.numpid,
        })
      } else {
        setRecordCount({
          value: resBigQuery.numpid,
          amountExcludeSales: filtersValues.excludeSales
            ? resBigQueryExclude
            : null,
          amountExcludeService: filtersValues.excludeService
            ? resBigQueryExclude
            : null,
        })
      }
      setSpiner(false)
    })
  }

  useEffect(() => {
    filtersValues.huntingShooting &&
      setHuntingShooting([{ name: "Yes", id: "0", selected: true }])
  }, [filtersValues.huntingShooting])

  return (
    <div className="flex flex-col items-center">
      <fieldset className="h-auto">
        <legend className="sr-only">Hunting Shooting</legend>
        <h1 className="font-bold text-[#586283] text-[20px] mb-4">
          Hunting Shooting
        </h1>
        {huntingShooting.map((item) => (
          <div className="flex items-center justify-center mb-4" key={item.id}>
            <input
              id={`${item.id}huntingshooting`}
              checked={item.selected}
              onChange={(event) => changeInput(event)}
              aria-describedby={`checkbox-${item.id}huntingshooting`}
              type="checkbox"
              className="w-4 h-4 text-[#298FC2] bg-[#298fc217] rounded border-gray-300 focus:ring-[#298FC2] focus:ring-2"
            />
            <label
              htmlFor={`${item.id}huntingshooting`}
              className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300"
            >
              {item.name}
            </label>
          </div>
        ))}
      </fieldset>
      <button
        onClick={handleHuntingShootingChange}
        type="button"
        className="flex flex-row justify-between text-white bg-[#298FC2] focus:ring-4 font-bold rounded-lg text-sm px-5 py-2.5 text-center mb-2"
      >
        Submit
        <img className="py-[2px] px-2" src={arrowup} alt="arrow" />
      </button>
    </div>
  )
}

export default IntHuntingShooting
